"use strict";
import { guests } from '../middleware/guests.js';
import { tables } from '../middleware/tables.js';
import { isMobile } from '../utils.js';
import feather from 'feather-icons';

const DEFAULT_MAX_SEATS = 10;
let tableCounter = 0;

function getGuestNameById(id, guestsList) {
  const guest = guestsList.find(g => g.id === id);
  return guest ? guest.name : "Inconnu";
}

function new_badge(guest, guestsList) {
  const confirmedClass = guest.is_confirmed
    ? guest.is_baby
      ? "baby"
      : guest.is_child
        ? "child"
        : "confirmed"
    : "unconfirmed";

  const options = (!guest.is_child && !guest.is_baby) ?
    `${guest.is_vege ? "<p class='vegeop m-0'>Végé</p>" : ""}
                    ${guest.is_notalcool ? "<p class='notal m-0'>Ne boit pas d'alcool</p>" : ""}`
    : guest.is_child ? `${guest.is_menuChild ? "<p class='mber m-0'>Menu Enfant</p>" : ""}` : "";
  const comeswith = guest.comeswith.length > 0
    ? `<div class="comes-with"><p class="m-0">comes with: <pre class="cwlv">${guest.comeswith.map(id => getGuestNameById(id, guestsList)).join("\n")}</pre></p></div>`
    : "";

  const badgeHtml = `
    <div id="guest-${guest.id}" class="mb-2 guest-badge-wrapper" draggable="true" data-id="${guest.id}">
      <button class="btn d-flex justify-content-between align-items-center text-start guest-badge ${confirmedClass} w-100" type="button"          
                  data-bs-toggle="collapse" data-bs-target="#collapse-${guest.id}">
              ${guest.name}
              <i class="remove-guest" style="cursor: pointer;" data-feather="x" data-id="${guest.id}"></i>
          </button>
          <div id="collapse-${guest.id}" class="collapse guest-badge-details p-2 border rounded bg-light w-100">
              <p class="tn m-0">Table: ${guest.table_number || "??"}</p>
              ${options}
              ${comeswith}
          </div>
      </div>`;
  const $badge = $(badgeHtml);

  //drag and drop pour dekstop
  $badge.on('dragstart', function (ev) {
    $(this).addClass('dragging');
    drag(ev);
  });

  $badge.on('dragend', function () {
    $(this).removeClass('dragging');
    $('.drop-indicator').remove();
  });

  //drag and drop pour mobile
  let touchGuestId = null;
  let touchStartTime = null;
  let isDragging = false;

  $badge.on('touchstart', function (ev) {
    if ($(ev.target).hasClass('remove-guest')) {
      return;
    }
    const touch = ev.touches[0];
    touchGuestId = $(this).attr('id');
    touchStartTime = Date.now();
    isDragging = false;
    ev.preventDefault();
  });

  $badge.on('touchmove', function (ev) {
    if (!touchGuestId) return;

    // Si l'utilisateur commence à glisser, annule le collapse
    if (Date.now() - touchStartTime > 200) { // Délai de 200 ms pour démarrer le glisser
      isDragging = true;
      $(this).addClass('dragging');
    }

    ev.preventDefault();
    const touch = ev.touches[0];
    const $target = $(document.elementFromPoint(touch.clientX, touch.clientY));
    const $table = $target.closest('.droppable-table');

    // Surbrillance de la table cible
    $('.droppable-table').removeClass('hovered');
    if ($table.length) {
      $table.addClass('hovered');
    }
  });

  $badge.on('touchend', function (ev) {
    if (!touchGuestId) return;

    $(this).removeClass('dragging');
    $('.droppable-table').removeClass('hovered');
    $('.drop-indicator').remove();

    // Si l'utilisateur n'a pas glissé, déclenche le collapse
    if (!isDragging) {
      $(this).find('[data-bs-toggle="collapse"]').trigger('click');
      touchGuestId = null;
      return;
    }

    const touch = ev.changedTouches[0];
    const $target = $(document.elementFromPoint(touch.clientX, touch.clientY));
    const $table = $target.closest('.droppable-table');
    const tableName = $table.data('name');

    if ($table.length) {
      const touchY = touch.clientY;
      const $guestElement = $(`#${touchGuestId}`);
      const $tableGuests = $table.find('.table-guests');
      const maxSeats = parseInt($table.data('max-seats'), 10);

      const currentGuests = $table.find(".guest-badge").not('.baby, .child').length;
      const $currentTable = $guestElement.closest('.droppable-table');

      if (!$currentTable.is($table) && !$guestElement.find('.guest-badge').is(".baby, .child") && currentGuests >= maxSeats) {
        alert(`La table "${tableName}" est pleine (${maxSeats} invités adultes maximum).`);
        return;
      }
      let insertBefore = null;
      $tableGuests.children().each(function () {
        const $guest = $(this);
        const guestRect = $guest[0].getBoundingClientRect();
        const guestCenterY = guestRect.top + (guestRect.height / 2);

        if (touchY < guestCenterY) {
          insertBefore = $guest;
          return false;
        }
      });

      if (insertBefore) {
        insertBefore.before($guestElement);
      } else {
        $tableGuests.append($guestElement);
      }

      // Mettre à jour les informations du badge
      const tableId = $table.attr('id'); // Récupérer l'ID de la table
      $guestElement.addClass('dropped');
      setTimeout(() => $guestElement.removeClass('dropped'), 300);
      $guestElement.find(".guest-badge").attr("data-table-id", tableId); // Utiliser tableId
      $guestElement.find("p.tn").text("Table : " + tableName);
    }

    touchGuestId = null;
    isDragging = false;
  });

  $badge.find('.remove-guest').on('touchstart', function (ev) {
    ev.stopPropagation();
  });

  return $badge;
}

function fillSelectGuests(guestsList) {
  try {
    const $select = $("#guestSelect");
    guestsList.forEach(guest => {
      $('#guestSelect').append(new Option(guest.name, guest.id));
    });

    $select.select2({
      placeholder: "Tapez pour rechercher...",
      allowClear: true,
      tags: true,
      width: isMobile() ? '100%' : '50%',
      initSelection: function (element, callback) {
      },
    });

    const $warning = $("<p id='guest-warning' class='text-danger mt-1'></p>");
    $select.after($warning);

    $select.on("change", function () {
      const selectedId = $(this).val();
      const selectedGuest = guestsList.find(g => g.id === selectedId);

      if (selectedGuest) {
        $("#guestSelect").val('').trigger('change');

        if (!selectedGuest.is_confirmed) {
          $('#guest-warning').text(`${selectedGuest.name} n'a pas confirmé`);
          setTimeout(() => {
            $('#guest-warning').text("");
          }, 3000);
          return;
        }

        $('#guest-warning').text("");
        if ($(`#guest-${selectedId}`).length) {
          $('#guest-warning').text(`${selectedGuest.name} est déjà dans une table/selection`);
          setTimeout(() => {
            $('#guest-warning').text("");
          }, 3000);
          return;
        };

        $("#selected-guests-container").append(new_badge(selectedGuest, guestsList));
        feather.replace();
      }
    });

    $(document).on("click", ".remove-guest", function () {
      const guestId = $(this).data("id");
      $(`#guest-${guestId}`).remove();
    });

  } catch (error) {
    console.error("Erreur lors du chargement des invités :", error);
  }
}
function generateRandomRGBA() {
  const r = Math.floor(Math.random() * 256);
  const g = Math.floor(Math.random() * 256);
  const b = Math.floor(Math.random() * 256);
  const a = 0.1;
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

function createTable(isToCallBackend, table, guestsList) {
  const tableName = table && table.name || $('#tableName').val().trim();
  const tableId = table && table.id || `table_${tableCounter}`;
  if (tableName === "" || tableId === "") {
    alert("Veuillez entrer un nom pour la table.");
    return;
  }
  const backgroundColor = table && table.backgroundColor || generateRandomRGBA();
  const tableMaxSeats = table && table.maxSeats || DEFAULT_MAX_SEATS;
  const tableDiv = `
    <div class="table-div mb-3 p-3 border rounded droppable-table" data-name="${tableName}" id="${tableId}" data-max-seats="${tableMaxSeats}" style="background-color: ${backgroundColor}">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center gap-4">
            <span class="table-name-text">
              ${tableName}
            </span>
            <input type="text" class="table-name-input" value="${tableName}">
            <div class="table-name-ctrls d-flex align-items-center gap-3">
              <span class="edit-table-name-container">
                <i class="edit-table-name" data-feather="edit"></i>
              </span>
              <div class="edit-table-name-sc-container">
                <span class="edit-table-name-save">
                  <i data-feather="save"></i>
                </span>
                <span class="edit-table-name-cancel">
                  <i data-feather="x"></i>
                </span>
              </div>
            </div>
          </div>
          <i class="remove-table" data-feather="x" data-id="${tableId}"></i>
        </div>
        <div class="table-guests d-flex flex-wrap gap-2 mt-3">
        
        </div>
        <div class="text-center mt-3">
            <i class="save-table" data-feather="save" data-id="${tableId}"></i>
        </div>
    </div>`;
  $('#tables-draw-container').append(tableDiv);

  $('#tableName').val('');
  tableCounter++;
  const $table = $(`#${tableId}`);
  const guestIds = table && table.guestIds || [];
  let confirmedCount = 0;
  let pasConfirmedCount = 0;
  if (guestIds.length > 0) {
    guestIds.forEach(guestId => {
      const guest = guestsList.find(g => g.id === guestId);
      if (guest) {
        if (guest.is_confirmed) {
          const $badge = new_badge(guest, guestsList);
          $table.find('.table-guests').append($badge);
          $badge.find(".guest-badge").attr("data-table-id", tableId);
          $badge.find("p.tn").text("Table : " + tableName);
          confirmedCount++;
        } else {
          pasConfirmedCount++;
          console.log(`${guest.name} n'a pas confirmé`);
        }
      }
    });
  }
  feather.replace();
  $table.on("dragover", allowDrop);
  $table.on("drop", drop);

  console.log(`Table ${tableId} créée avec ${confirmedCount} invités. (${pasConfirmedCount} pas confirmé)`);
  if (isToCallBackend) {
    const newTable = {
      "id": tableId,
      "name": tableName,
      "maxSeats": tableMaxSeats,
      "guestIds": [],
      "backgroundColor": backgroundColor,
    }
    tables.addTable(newTable).then((result) => {
      if (result) {
        console.log("Table ajoutée avec succès sur le backend !");
      } else {
        console.error("Erreur lors de l'ajout de la table sur le backend.");
      }
    });
  }
}

$(document).on("click", ".remove-table", function () {
  const confirmation = confirm("Êtes-vous sûr de vouloir supprimer cette table ?");

  if (confirmation) {
    const tableId = $(this).data("id");
    $(`#${tableId} .guest-badge`).each(function () {
      $(this).removeAttr("data-table-id");
    });
    $(`#${tableId}`).remove();
    tables.deleteTable(tableId).then((result) => {
      if (result) {
        console.log("Table supprimée du backend avec succès !");
      } else {
        console.error("Erreur lors de la suppression de la table du backend.");
      }
    });
  }
});

$(document).on("click", ".save-table", function () {
  const tableId = $(this).data("id");
  const tableName = $(`#${tableId} .table-name-text`).text().trim();
  const guestIds = $(`#${tableId} [id^="guest-"]`).map(function () {
    return $(this).data("id");
  }).get();
  const tableToSave = {
    id: tableId,
    name: tableName,
    guestIds: guestIds
  };
  tables.updateTables([tableToSave]).then((result) => {
    if (result) {
      alert(`Table "${tableName}" (${tableId}) enregistrée avec succès ! Invités : ${guestIds.join(", ")}`);
    } else {
      alert("Erreur lors de l'enregistrement de la table. Veuillez réessayer.");
    }
  });
});

$(document).on('click', '.edit-table-name', function () {
  const $parent = $(this).closest('.table-name-ctrls');
  const $text = $parent.siblings('.table-name-text');
  const $input = $parent.siblings('.table-name-input');
  $text.hide();
  $input.show().focus();
  $parent.find('.edit-table-name-container').hide();
  $parent.find('.edit-table-name-sc-container').show();
});

$(document).on('click', '.edit-table-name-save', async function () {
  const $parent = $(this).closest('.table-name-ctrls');
  const $text = $parent.siblings('.table-name-text');
  const $input = $parent.siblings('.table-name-input');
  const tableId = $input.closest('.droppable-table').attr('id');
  const newName = $input.val().trim();
  if (newName === "") {
    alert("Le nom de la table ne peut pas être vide.");
    return;  // Si le nom est vide, on ne continue pas
  }
  $text.text(newName).show();
  $input.hide();
  $parent.find('.edit-table-name-sc-container').hide();
  $parent.find('.edit-table-name-container').show();
  const result = await tables.updateTableName(tableId, newName);
  if (result) {
    alert(`Le nom de la table "${tableId}" a été mis à jour avec succès.`);
  } else {
    alert("Une erreur est survenue lors de la mise à jour du nom de la table.");
  }
});

$(document).on('click', '.edit-table-name-cancel', function () {
  const $parent = $(this).closest('.table-name-ctrls');
  const $text = $parent.siblings('.table-name-text');
  const $input = $parent.siblings('.table-name-input');
  $input.val($text.text().trim()).hide();
  $text.show();
  $parent.find('.edit-table-name-sc-container').hide();
  $parent.find('.edit-table-name-container').show();
});

function allowDrop(ev) {
  ev.preventDefault();
}
function drag(ev) {
  ev.originalEvent.dataTransfer.setData("guestId", ev.target.id);
}

function drop(ev) {
  ev.preventDefault();

  const guestId = ev.originalEvent.dataTransfer.getData("guestId");
  if (!guestId) return;

  const $guestElement = $(`#${guestId}`);
  if ($guestElement.length === 0) return;

  const $table = $(ev.target).closest('.droppable-table');
  if ($table.length === 0) return;

  const tableId = $table.attr('id');
  const tableName = $table.data('name');
  const maxSeats = parseInt($table.data('max-seats'), DEFAULT_MAX_SEATS);
  const currentGuests = $table.find('.guest-badge').not('.baby, .child').length;
  const $currentTable = $guestElement.closest('.droppable-table');

  if (!$currentTable.is($table) && !$guestElement.find('.guest-badge').is(".baby, .child") && currentGuests >= maxSeats) {
    alert(`La table "${tableName}" est pleine (${maxSeats} invités adultes maximum).`);
    return;
  }

  const mouseX = ev.originalEvent.clientX;
  const mouseY = ev.originalEvent.clientY;
  let $closestGuest = null;
  let closestDistance = Infinity;

  const $tableGuests = $table.find('.table-guests');

  let rows = {};
  $tableGuests.children().each(function () {
    const $guest = $(this);
    const guestRect = $guest[0].getBoundingClientRect();
    const guestTop = guestRect.top;

    if (!rows[guestTop]) {
      rows[guestTop] = [];
    }
    rows[guestTop].push({
      element: $guest,
      centerX: guestRect.left + guestRect.width / 2
    });
  });

  let closestRow = null;
  let minRowDistance = Infinity;
  Object.keys(rows).forEach(rowTop => {
    const distanceY = Math.abs(mouseY - rowTop);
    if (distanceY < minRowDistance) {
      minRowDistance = distanceY;
      closestRow = rowTop;
    }
  });

  if (closestRow !== null) {
    rows[closestRow].forEach(guest => {
      const distanceX = Math.abs(mouseX - guest.centerX);
      if (distanceX < closestDistance) {
        closestDistance = distanceX;
        $closestGuest = guest.element;
      }
    });
  }

  if ($closestGuest) {
    const guestRect = $closestGuest[0].getBoundingClientRect();
    const guestCenterX = guestRect.left + guestRect.width / 2;

    if (mouseX < guestCenterX) {
      $closestGuest.before($guestElement);
    } else {
      $closestGuest.after($guestElement);
    }
  } else {
    $tableGuests.append($guestElement);
  }

  // Mettre à jour les infos du badge
  $guestElement.addClass('dropped');
  setTimeout(() => $guestElement.removeClass('dropped'), 300);
  $guestElement.find(".guest-badge").attr("data-table-id", tableId);
  $guestElement.find("p.tn").text("Table : " + tableName);
}

export function initTables() {
  try {
    $("#tables-container").load('../../components/tables.html', async function () {
      feather.replace();
      const tablesList = await tables.getTables() || [];
      const guestsList = await guests.getGuests() || [];
      fillSelectGuests(guestsList);
      tablesList.forEach(table => {
        createTable(false, table, guestsList)
      });
      $('#createTableBtn').on('click', function () {
        createTable(true);
      })
    });
    console.log("fin : initTables")
  } catch (error) {
    console.error("Erreur lors du chargement des tables :", error);
  }
}